import { ParametrosClienteFielInicial } from "../models/parametrosClienteFielModel"
import type { ParametrosClienteFielModel } from "../models/parametrosClienteFielModel"
import { ParametrosClienteFielActionsTypes } from "./parametrosClienteFielActions"
import type { ParametrosClienteFielActionModel } from "./parametrosClienteFielActions"

export function parametrosClienteFielReducer(
    state: ParametrosClienteFielModel,
    action: ParametrosClienteFielActionModel
): ParametrosClienteFielModel {
    switch (action.type) {
        case ParametrosClienteFielActionsTypes.CARREGAR:
            return action.payload

        case ParametrosClienteFielActionsTypes.ATUALIZAR_CAMPO:
            return {
                ...state,
                [action.payload.campo]: action.payload.valor,
            }

        case ParametrosClienteFielActionsTypes.RESETAR:
            return ParametrosClienteFielInicial

        default:
            return state
    }
}
